import { opensTurn } from '@littlebird/ui-utils';

type MessageWithBrowserModalities = {
  modalitiesUsed?: readonly { type: string; action?: unknown }[] | null;
  joinedTurn?: boolean;
};

const inactiveBrowserActions = new Set([
  'stop',
  'sign_in',
  'sign_in_status',
  'list_logins',
]);

export const chatHasActiveBrowserUse = (
  messages: readonly MessageWithBrowserModalities[] | undefined | null
): boolean => {
  let active = false;
  for (const message of messages ?? []) {
    for (const modality of message.modalitiesUsed ?? []) {
      if (
        modality.type !== 'browser_use' ||
        typeof modality.action !== 'string'
      )
        continue;
      active = !inactiveBrowserActions.has(modality.action);
    }
  }
  return active;
};

export function currentTurnUsesBrowser(
  messages: readonly (MessageWithBrowserModalities & { role: string })[]
): boolean {
  let active = false;
  let turnStart = 0;
  for (let index = messages.length - 1; index >= 0; index--) {
    if (opensTurn(messages[index])) {
      turnStart = index + 1;
      break;
    }
  }
  for (let index = turnStart; index < messages.length; index++) {
    const message = messages[index];
    if (message.role !== 'assistant') continue;
    for (const modality of message.modalitiesUsed ?? []) {
      if (
        modality.type !== 'browser_use' ||
        typeof modality.action !== 'string'
      )
        continue;
      active = !inactiveBrowserActions.has(modality.action);
    }
  }
  return active;
}
